<ng-container *ngIf=datePickerCtrl.active>
    <div class="calendar no-select" tabindex="0" [focus]="true" (focusout)="hide()"
         [style.top.px]="datePickerCtrl.position.top + datePickerCtrl.position.height + 5"
         [style.left.px]="datePickerCtrl.position.left + datePickerCtrl.position.width / 2 - 150">
        <div class="row" [style.backgroundColor]="'#f0f0f0'">
            {{ month_names[current_month] }}
        </div>
        <div class="row" [style.backgroundColor]="'#f0f0f0'">
            <ng-container *ngFor="let day of day_names">
                <div class="day-name">{{ day }}</div>
            </ng-container>
        </div>

        <ng-container *ngFor="let w of week">
            <div class="row">
                <ng-container *ngFor="let d of days">
                    <div class="day"
                         [ngClass]="{'today': getDate(d + w * 7).day == current_day && getDate(d + w * 7).month == current_month, 'gray': getDate(d + w * 7).month != current_month}"
                         (click)="click(d + w * 7)"
                    >{{ getDate(d + w * 7).day }}</div>
                </ng-container>
            </div>
        </ng-container>

        <div class="separator"></div>

        <div class="row-2">
            <div class="time">
                <div class="col">
                    <i class="arrow fas fa-caret-up" (click)="clickHours(1)"></i>
                    <div class="number" (wheel)="onWheelTime($event, 'h')">
                        {{ hours < 10 ? '0' + hours : hours }}
                    </div>
                    <i class="arrow fas fa-caret-down" (click)="clickHours(-1)"></i>
                </div>
                :
                <div class="col">
                    <i class="arrow fas fa-caret-up" (click)="clickMinutes(5)"></i>
                    <div class="number" (wheel)="onWheelTime($event, 'm')">
                        {{ minutes < 10 ? '0' + minutes : minutes }}
                    </div>
                    <i class="arrow fas fa-caret-down" (click)="clickMinutes(-5)"></i>
                </div>
                :
                <div class="col">
                    <i class="arrow fas fa-caret-up" (click)="clickSeconds(5)"></i>
                    <div class="number" (wheel)="onWheelTime($event, 's')">
                        {{ seconds < 10 ? '0' + seconds : seconds }}
                    </div>
                    <i class="arrow fas fa-caret-down" (click)="clickSeconds(-5)"></i>
                </div>
            </div>

            <div class="utc">
                <div class="col">
                    <i class="arrow fas fa-caret-up" (click)="clickUTC(1)"></i>
                    <div class="number" (wheel)="onWheelTime($event, 'utc')">
                        {{ utc }}
                    </div>
                    <i class="arrow fas fa-caret-down" (click)="clickUTC(-1)"></i>
                </div>
            </div>
        </div>
    </div>
</ng-container>
